import axios from "axios";
import { errorMsg } from "../Components/Toastify";

const Auth = () => {
  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error?.response?.status === 401) {
        logoutUser();
        return;
      } else if (error?.response?.status === 403) {
        errorMsg("Don't have a access")
      }
      return Promise.reject(error);
    }
  );
};

export default Auth;

const logoutUser = () => {
  localStorage.clear();
};
